<template>
    <div class="settings-dropdown">
      <div class="item" @click="goToProfile">
        👤 <span>Профиль</span>
      </div>
  
      <div class="item" @click="goToSettings">
        ⚙️ <span>Настройки</span>
      </div>
  
      <div class="separator"></div>
  
      <div class="item logout" @click="logout">
        🚪 <span>Выйти</span>
      </div>
    </div>
  </template>
  
  <script setup>
  const goToProfile = () => {
    console.log("Перешли в профиль");
  };
  
  const goToSettings = () => {
    console.log("Перешли в настройки");
  };
  
  const logout = () => {
    console.log("Выход");
  };
  </script>
  
  <style scoped>
  
  .settings-dropdown {
    position: absolute;
    top: 60px;
    right: 20px;
    min-width: 180px;
    background: var(--card-bg);
    border-radius: 14px;
    padding: 8px 0;
    box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.25);
    display: flex;
    flex-direction: column;
    isolation: isolate;
    animation: fadeInScale 0.15s ease-out;
    z-index: 9999;
  }
  
  @keyframes fadeInScale {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  
  .item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 18px;
    font-family: "Eastman-Regular", sans-serif;
    font-size: 14px;
    color: var(--text);
    cursor: pointer;
    transition: background-color 0.2s ease, color 0.2s ease;
    border-radius: 8px;
  }
  
  .item:hover {
    background: rgba(255, 255, 255, 0.05);
    color: var(--primary-color);
  }
  
  .logout {
    color: #e63946;
  }
  
  .logout:hover {
    background: rgba(230, 57, 70, 0.1);
  }
  
  .separator {
    height: 1px;
    background-color: rgba(255, 255, 255, 0.07);
    margin: 4px 0;
  }
  </style>